import { render, staticRenderFns } from "./RentalCarPricingRepairShopForm.vue?vue&type=template&id=81aab4a8&scoped=true"
import script from "./RentalCarPricingRepairShopForm.vue?vue&type=script&lang=js"
export * from "./RentalCarPricingRepairShopForm.vue?vue&type=script&lang=js"
import style0 from "./RentalCarPricingRepairShopForm.vue?vue&type=style&index=0&id=81aab4a8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aab4a8",
  null
  
)

export default component.exports